import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import BulkOrders from "./BulkOrders";
import Footer from "./Footer";
const UploadBulkOrders = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <BulkOrders />
      <Footer />
    </>
  );
};

export default UploadBulkOrders;
